(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      // Initialize all video sections
      const videoSections = document.querySelectorAll('[data-section-type="video-section"]');

      videoSections.forEach(function(section) {
        initVideoSection(section);
      });

      function initVideoSection(section) {
    const sectionId = section.getAttribute('data-section-id');
    const videoWrapper = section.querySelector('.video-wrapper');
    const html5Video = section.querySelector('.html5-video');
    const iframeLazy = section.querySelector('.js-lazyframe');
    const playButtons = section.querySelectorAll('[data-play-video-button]');

    // Initialize YouTube iframe API if needed
    if (iframeLazy && iframeLazy.classList.contains('youtube-wrapper')) {
      loadYouTubeAPI();
    }

    // Add click event for the video element (separate from controls)
    if (html5Video) {
      videoWrapper.addEventListener('click', function(e) {
        // Check if the click was on the video controls
        // This prevents the toggle when clicking on controls
        if (!e.target.closest('.video-controls') && e.target !== html5Video && !e.target.closest('button')) {
          if (html5Video.paused) {
            html5Video.play();
          } else {
            html5Video.pause();
          }
        }
      });
    }

    // Lazy load iframes
    if (iframeLazy) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const iframe = entry.target;
            iframe.src = iframe.getAttribute('data-src');
            observer.unobserve(iframe);
          }
        });
      }, { rootMargin: '100px' });

      observer.observe(iframeLazy);
    }

    // Setup play button functionality
    playButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();

        if (html5Video) {
          html5Video.play();
        } else if (iframeLazy) {
          // For iframes, we need to force loading if not already loaded
          if (!iframeLazy.src) {
            iframeLazy.src = iframeLazy.getAttribute('data-src');
          }

          // Add autoplay=1 parameter if not already present
          if (iframeLazy.src.indexOf('autoplay=1') === -1) {
            iframeLazy.src = iframeLazy.src.replace('autoplay=0', 'autoplay=1');
          }
        }
      });
    });
  }

      function loadYouTubeAPI() {
        if (window.YT) return;

        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    });

  } catch(e) { console.error(e); }
})();
})();
